import { trackEvent } from '../../../../utils/user-tracking';

// Eventi dello Smart multi-store, tutti nella categoria 'smart multi-store': pannello dei
// centri aperto, ricerca confermata in N centri, ritorno al centro di partenza, orario scelto
// in un altro centro e cambio centro
export const trackMultiStore = (label: string): void => {
  trackEvent({
    action: 'Azione utente',
    category: 'smart multi-store',
    label,
    url: location.pathname,
  });
};

export const trackMultiStorePanelOpened = (): void => {
  trackMultiStore('pannello aperto');
};

export const trackMultiStoreSearch = (count: number): void => {
  trackMultiStore(`cerca in ${count} centri`);
};

export const trackMultiStoreBackToOrigin = (): void => {
  trackMultiStore('ritorno al centro di partenza');
};
